import React from "react";
import { Container } from "@material-ui/core";
import { pagesStore } from "pages/_stores/pagesStore";
import { LoadableFromLoading } from "_common/loaders/LoadableFromLoading";
import { BlogCard } from "home/sections/BlogCard";
import clsx from "clsx";
import styles from "./_css/blog.module.css";
import { useTranslation } from "react-i18next";
import { URLS } from "_configs/URLS";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";

export function Blog() {
    const { t } = useTranslation();
    return (
        <LoadableFromLoading
            loading={pagesStore.getLatestArticles(3)}
            renderer={(_status, _error, latestArticles) => {
                if (!latestArticles || latestArticles.length === 0) return null;
                const [featured, ...others] = latestArticles;
                return (
                    <Container className={styles.container}>
                        <div className={styles.header}>
                            <div className={styles.headerText}>
                                <h2 className={styles.title}>
                                    {t("homePage.blog.titlePrefix")}{" "}
                                    <span className={styles.titleAccent}>{t("homePage.blog.titleAccent")}</span>
                                </h2>
                                <p className={styles.subtitle}>{t("homePage.blog.subtitle")}</p>
                            </div>
                            <a className={styles.seeAll} href={URLS.blog()}>
                                {t("homePage.blog.seeAll")}
                                <ArrowRightAltIcon className={styles.seeAllArrow} />
                            </a>
                        </div>
                        <div className={styles.grid}>
                            {featured && (
                                <BlogCard
                                    variant="featured"
                                    blogType={featured.blogType}
                                    date={featured.localized.publishedAt}
                                    title={featured.localized.title}
                                    text={featured.localized.description}
                                    image={featured.localized.image}
                                    url={featured.localized.url}
                                />
                            )}
                            <div className={clsx(styles.column, "flex_column")}>
                                {others.map((article) => (
                                    <BlogCard
                                        key={article._id}
                                        variant="compact"
                                        blogType={article.blogType}
                                        date={article.localized.publishedAt}
                                        title={article.localized.title}
                                        text={article.localized.description}
                                        image={article.localized.image}
                                        url={article.localized.url}
                                    />
                                ))}
                            </div>
                        </div>
                    </Container>
                );
            }}
        />
    );
}
